import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iuf_avatar = _resolveComponent("iuf-avatar")!

  return (_ctx.userProfile)
    ? (_openBlock(), _createBlock(_component_iuf_avatar, _mergeProps({
        key: 0,
        "data-type": _ctx.userProfileDataType,
        object: _ctx.userProfile,
        text: _ctx.text,
        field: "avatar"
      }, _ctx.AVATAR_PROPS.USER), null, 16, ["data-type", "object", "text"]))
    : _createCommentVNode("", true)
}